export const BIWEEKLY = 2; // Payday every 2 weeks
export const ENDOFDAYHOURS = 23; // Last hour of the day
export const ENDOFDAYMINUTES = 59; // Last minute of the day
export const ENDOFDAYSECONDS = 59; // Last second of the day
export const STARTOFDAYTIME = 0; // Time for Hours, Minutes, and Seconds always going to be zero to get the first moments of the day
export const NEXT = 1; // Advances one
export const PREVIOUS = -1; // Retracts one
export const EVENTLIMIT = 3; // Max events to display
export const NOTFOUND = -1; // Value not found

export const AM = 'AM'
export const PM = 'PM'
export const PMTIMEADJUSTMENT = 12; // Have to add 12 hours for PM because it does not automatically adjust for them
export const PMTIMESTART = 12; // The time that that is right before all PM times begin
export const AMTIMESTART = 0; // The time that that is right before all AM times begin

export const STARTTIME = 'start';
export const ENDTIME = 'end';

export const DARKTHEME = 'dark-theme';
export const LIGHTTHEME = 'light-theme';
export const PORTALDARKTHEME = 'portal-dark-theme';
export const PORTALLIGHTTHEME = 'portal-light-theme';
